module.exports = __webpack_public_path__ + "img/tab4s.046f68c8.jpg";